import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Project } from '../../models/project';

@Injectable({
  providedIn: 'root'
})
export class InterestCategoriesService {

  supportsInterestCategories(project: Project): boolean {
    const latestCrawlDate = project?.audience_target?.latest_crawl?.created_at;
    return !!latestCrawlDate && new Date(latestCrawlDate).getTime() >= this.newTagsCutoffMs();
  }

  private newTagsCutoffMs(): number {
    return new Date(environment.config.interestCategories.newTagsCutoff).getTime();
  }
}
